export default {
  data() {
    return {
      cropperReady: false,
      showCropper: false,
      showFilters: false,
      filter: null,
      originalPhotoWidth: 0,
      originalPhotoHeight: 0,
    };
  },
  methods: {
    init() {
      if (this.drawing && this.drawing.photo && this.drawing.photo.processing && this.drawing.photo.processing.cropper) {
        /*const selection = this.drawing.photo.processing.cropper.selection;
        const selectionCropBox = this.drawing.photo.processing.cropper.selectionCropBox;

        if (selectionCropBox) {
          // this.$refs.cropper.setCropBoxData(this.convertCropBoxData(selectionCropBox));
        } else {
          //
        }

        if (selection) {
          this.$refs.cropper.setData(this.convertData(selection));
        }*/

        const data = this.drawing.photo.processing.cropper.data;
        const cropBoxData = this.drawing.photo.processing.cropper.cropBoxData;

        try {
          this.$refs.cropper.setData(data);
          this.$refs.cropper.setCropBoxData(cropBoxData);

          // this.$refs.cropper.setAspectRatio(this.getAspectRatio(this.drawing.photo, this.drawing.sizes));
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      }

      this.renderPreview();
      this.cropperReady = true;
    },
    renderPreview() {
      const canvas = this.$refs.cropper ? this.$refs.cropper.getCroppedCanvas() : null;
      const base64 = canvas ? canvas.toDataURL('image/jpeg') : '';
      const previewContainer = this.$refs.preview;

      if (previewContainer) {
        previewContainer.setAttribute('src', base64);
      }

      if (this.$refs.originalPhoto) {
        this.originalPhotoWidth = this.$refs.originalPhoto.width;
        this.originalPhotoHeight = this.$refs.originalPhoto.height;

        //this.initCropperWrap();
      }
    },
    control(control) {
      let dom, scale;
      const cropBoxData = this.$refs.cropper.getCropBoxData();

      switch (control) {
        case 'flip':
          dom = document.getElementById('flip-x');

          scale = dom.getAttribute('data-scale');
          scale = scale ? -scale : -1;

          this.$refs.cropper.scaleX(scale);
          dom.setAttribute('data-scale', scale);
          break;
        case 'landscape':
        case 'portrait':
          if (cropBoxData.width && cropBoxData.height) {
            if (cropBoxData.width > cropBoxData.height && control ===
                'portrait' || cropBoxData.width < cropBoxData.height &&
                control === 'landscape') {
              this.$refs.cropper.setAspectRatio(
                  cropBoxData.height / cropBoxData.width);
            }
          }
          break;
      }
    },
    zoom(e) {
      e.preventDefault();
    },
    crop() {
      this.renderPreview();
      this.showCropper = false;
    },
    resetCrop() {
      this.$refs.cropper.reset();
    },
    setFilter(filter) {
      this.filter = filter;
      this.showFilters = false;
    },
    getSelectionData(data) {
      let result = null;

      if (data) {
        result = {
          type: null,
          width: parseFloat((data.width / this.$refs.originalPhoto.width).toFixed(6)),
          height: parseFloat((data.height / this.$refs.originalPhoto.height).toFixed(6)),
          x: parseFloat((data.x / this.$refs.originalPhoto.width).toFixed(6)),
          y: parseFloat((data.y / this.$refs.originalPhoto.height).toFixed(6)),
          'flip-x': data.scaleX < 0,
          orientation: data.width > data.height
              ? 'landscape' : 'portrait',
        };
      }

      return result;
    },
    convertData(data) {
      return {
        width: parseFloat(data.width * this.$refs.originalPhoto.width),
        height: parseFloat(data.height * this.$refs.originalPhoto.height),
        x: parseFloat(data.x * this.$refs.originalPhoto.width),
        y: parseFloat(data.y * this.$refs.originalPhoto.height),
        scaleX: data['flip-x'] ? -1 : 1,
      };
    },
    getSelectionCropBoxData(cropBoxData) {
      const containerWidth = this.$refs.cropper.getContainerData().width;
      const containerHeight = this.$refs.cropper.getContainerData().height;
      let result = null;

      if (cropBoxData) {
        result = {
          width: parseFloat((cropBoxData.width / containerWidth).toFixed(6)),
          height: parseFloat((cropBoxData.height / containerHeight).toFixed(6)),
          left: parseFloat((cropBoxData.left / containerWidth).toFixed(6)),
          top: parseFloat((cropBoxData.top / containerHeight).toFixed(6)),
        };
      }

      return result;
    },
    convertCropBoxData(cropBoxData) {
      const containerWidth = this.$refs.cropper.getContainerData().width;
      const containerHeight = this.$refs.cropper.getContainerData().height;
      const result = {
        width: parseFloat(cropBoxData.width) * containerWidth,
        height: parseFloat(cropBoxData.height) * containerHeight,
        left: parseFloat(cropBoxData.left) * containerWidth,
        top: parseFloat(cropBoxData.top) * containerHeight,
      };

      return result;
    },
    modify() {
      let order, set, photo, product, productIndex;

      switch (this.$route.name) {
        case 'album':
        case 'tag':
          set = this.set;

          if (set && set.products) {
            productIndex = this._.findIndex(set.products,
                {id: this.drawing.photo.productId});
            product = set.products[productIndex];

            if (product) {
              product.photo.processing.cropper.data = this.$refs.cropper.getData();
              product.photo.processing.cropper.cropBoxData = this.$refs.cropper.getCropBoxData();
              product.photo.processing.cropper.selection = this.getSelectionData(
                  product.photo.processing.cropper.data);
              product.photo.processing.cropper.selectionCropBox = this.getSelectionCropBoxData(
                  product.photo.processing.cropper.cropBoxData);

              if (this.filter) {
                product.photo.processing.filter = this.filter;
              }
            }

            set.products[productIndex] = product;

            this.$store.commit('SET_SET', set);
            this.$store.dispatch('SET_COMPLETED_DRAWING', this.drawing);
          }

          break;
        case 'order':
          order = this.myOrder;
          photo = this._.find(order.photos, {id: this.drawing.photo.id});

          if (photo) {
            order.photos = order.photos.map(photo => {
              if (photo.id === this.drawing.photo.id) {
                photo.processing.cropper.data = this.$refs.cropper.getData();
                photo.processing.cropper.cropBoxData = this.$refs.cropper.getCropBoxData();
                photo.processing.cropper.selection = this.getSelectionData(photo.processing.cropper.data);
                photo.processing.cropper.selectionCropBox = this.getSelectionCropBoxData(photo.processing.cropper.cropBoxData);

                if (this.filter) {
                  photo.processing.filter = this.filter;
                }
              }

              return photo;
            });

            this.$store.dispatch('SET_ORDER', order);
            this.$store.dispatch('SET_COMPLETED_DRAWING', this.drawing);
          }
          break;
      }

      this.closePhotoEditor();
    },
    closePhotoEditor() {
      this.$store.dispatch('SET_DRAWING', null);
    },
    initCropperWrap() {
      let imageWidth = this.originalPhotoWidth;
      let imageHeight = this.originalPhotoHeight;

      const imageRatio = imageWidth / imageHeight;
      const cropperWrap = document.querySelector('.cropper-wrap');

      if (cropperWrap) {
        const areaWidth = cropperWrap.clientWidth;
        const areaHeight = cropperWrap.clientHeight;

        if (areaWidth > areaHeight) {
          if (imageRatio >= 1) { // landscape
            imageWidth = areaWidth;
            imageHeight = imageWidth / imageRatio;

            if (imageHeight > areaHeight) {
              imageHeight = areaHeight;
              imageWidth = areaHeight * imageRatio;
            }
          } else { // portrait
            imageHeight = areaHeight;
            imageWidth = imageHeight * imageRatio;

            if (imageWidth > areaWidth) {
              imageWidth = areaWidth;
              imageHeight = areaWidth / imageRatio;
            }
          }
        } else {
          if (imageRatio < 1) { // landscape
            imageWidth = areaWidth;
            imageHeight = imageWidth / imageRatio;

            if (imageHeight > areaHeight) {
              imageHeight = areaHeight;
              imageWidth = areaHeight * imageRatio;
            }
          } else { // portrait
            imageHeight = areaHeight;
            imageWidth = imageHeight * imageRatio;

            if (imageWidth > areaWidth) {
              imageWidth = areaWidth;
              imageHeight = areaWidth / imageRatio;
            }
          }
        }

        cropperWrap.style.width = `${imageWidth}px`;
        cropperWrap.style.height = `${imageHeight}px`;
      }
    }
  },
  mounted() {
    window.addEventListener('resize', () => this.initCropperWrap());
  }
};
